// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L0X_","col":"styles_col__2Q_gk","actions":"styles_actions__3q5M2","conflict":"styles_conflict__3c_XK"};